import { ReplayLoadingBackdrop, ReplayLoadingContent, ReplayLoadingOverlay } from "@Components/game/session-results/feedback/styled-components";
import Icon from "@Components/generic/icon";
import { faGear } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Box, Typography } from "@mui/material";

const FeedbackReplayNotFoundState = () => {
  const { i18n } = useI18n();
  const message = i18n("session-results.not-found");

  return (
    <ReplayLoadingOverlay role="status" aria-label={message} isComplete={false}>
      <ReplayLoadingBackdrop />

      <ReplayLoadingContent alignItems="center" justifyContent="center" padding={3}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2} width="35%">
          <Icon icon={faGear} size="3x" color="white" />

          <Typography variant="text2xl600" color="white" textAlign="center">
            {message}
          </Typography>
        </Box>
      </ReplayLoadingContent>
    </ReplayLoadingOverlay>
  );
};

export default FeedbackReplayNotFoundState;
